import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import type { GroupFoldersStore } from '../store/schema/GroupFoldersStore';
import type { GroupFolderHierarchy } from '../store/schema/GroupFolderHierarchy';
import { getLeftNavGroupFolders } from '../store/store';

export default function getLeftNavGroupFoldersStore(mailboxInfo: MailboxInfo): GroupFoldersStore {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const folderTableStates = getLeftNavGroupFolders().folderTableByMailboxInfo.get(accountKey);

    if (!folderTableStates) {
        const defaultFolderTable: GroupFoldersStore = {
            folderTable: new Map<string, GroupFolderHierarchy>(),
        };

        getLeftNavGroupFolders().folderTableByMailboxInfo.set(accountKey, defaultFolderTable);

        return defaultFolderTable;
    }

    return folderTableStates;
}
